import { render, staticRenderFns } from "./DeleteEmailMessageDialog.vue?vue&type=template&id=9dbd7f7a"
import script from "./DeleteEmailMessageDialog.vue?vue&type=script&lang=js"
export * from "./DeleteEmailMessageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports